import type { EmployeeViewModel, FunctionViewModel } from '@trinnvis/dabih-api-client';

export function isTreatmentHelper(e: EmployeeViewModel, functions: FunctionViewModel[]): boolean {
  const treatmentHelperFunctions = functions.filter(function (item) {
    return (
      item.employees.includes(e.uuid) &&
      (item.templateId === 171 || // akuttrom/skifterom
        item.templateId === 174 || // laboratorium
        item.templateId === 168 || // pasientmottak
        item.templateId === 7079) // tannhelsesekretær/assistent
    );
  });
  return treatmentHelperFunctions.length > 0;
}
